/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import { useMemo, useEffect, useState } from "react";

import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import './i18n/config';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { MaterialUIControllerProvider } from "context";
import { AuthProvider } from "context/AuthContext";

const container = document.getElementById("app");
const root = createRoot(container);

const Index = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);


  const validateToken = async () => {
    const token = localStorage.getItem('googleToken');
    if (!token) {
      return false;
    }

    const response = await fetch(`https://oauth2.googleapis.com/tokeninfo?id_token=${token}`);
    const data = await response.json();

    if (data.error) {
      return false;
    }

    return true;
  };

  const checkTokenValidity = async () => {
    const isValid = await validateToken();
    setIsLoggedIn(isValid);
  };

  useEffect(() => {
    checkTokenValidity();
    const interval = setInterval(checkTokenValidity, 60 * 10 * 1000); // Check every 10 min
    return () => clearInterval(interval);
  }, []);

  return (
    <BrowserRouter>
        <MaterialUIControllerProvider>
    <GoogleOAuthProvider clientId="192905142680-ebbv4d9aqpplp1tsv8ojatt0hqnnqhdq.apps.googleusercontent.com">
          <AuthProvider>
            <App />
          </AuthProvider>
    </GoogleOAuthProvider>
        </MaterialUIControllerProvider>
      </BrowserRouter>
  );
};

root.render(<Index />);
